import styled from '@emotion/styled'

import { breakpoints, NativeLink } from 'main/ui'

export const SpaceBetweenFlexSpan = styled.span`
  display: flex;
  flex-direction: column;
  padding-left: 0;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const LinkWithLeftPaddingSometimes = styled(NativeLink)`
  white-space: nowrap;
  padding-left: 0;

  @media (min-width: ${breakpoints.lg}px) {
    padding-left: 1rem;
  }
`

export const NetworkRatingLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const Stars = styled.span`
  width: 6rem;
  padding-left: 4px;
`
